export default __webpack_public_path__ + "images/vdxb-login-graphic.svg";